(function(){
 'use strict';
 if(!document.querySelector('[data-nt-home-pdp]'))return;
 function formatTitle(){
  var root=document.querySelector('[data-nt-product]'),heading=root&&root.querySelector('h1');
  if(!heading||heading.querySelector('.nt-home-product-prefix'))return;
  var brand=root.dataset.vehicleBrand,models=root.dataset.vehicleModels,years=(root.dataset.modelYears||'').split(',').filter(Boolean);
  if(!brand||!models||!years.length)return;
  var badges=Array.from(heading.querySelectorAll('.nt-us-stock-label,.nt-presale-label'));
  var prefix=document.createElement('span');prefix.className='nt-home-product-prefix';prefix.textContent='Fairing Kit for '+brand;
  var model=document.createElement('span');model.className='nt-home-product-model';model.textContent=models.split('||').map(function(m){return m.trim().replace(/GSX[ -]?R\s*(\d+)/ig,'GSX-R$1');}).join(' / ');
  var year=document.createElement('span');year.className='nt-home-product-years';year.textContent=years[0]+(years.length>1?'–'+years[years.length-1]:'');
  heading.replaceChildren.apply(heading,badges.concat([prefix,model,document.createTextNode(' '),year]));
 }
 var scheduled=false;
 function schedule(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;formatTitle();});}
 new MutationObserver(schedule).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});
 document.addEventListener('nt:product:mount',schedule);formatTitle();
})();
